import { render, staticRenderFns } from "./InterviewTest.vue?vue&type=template&id=74a54cb5&scoped=true&"
import script from "./InterviewTest.vue?vue&type=script&lang=js&"
export * from "./InterviewTest.vue?vue&type=script&lang=js&"
import style0 from "./InterviewTest.vue?vue&type=style&index=0&id=74a54cb5&lang=scss&scoped=true&"
import style1 from "./InterviewTest.vue?vue&type=style&index=1&id=74a54cb5&lang=scss&scoped=true&"
import style2 from "./InterviewTest.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a54cb5",
  null
  
)

/* custom blocks */
import block0 from "./InterviewTest.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./InterviewTest.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
